<template>

    <div v-cloak class="container-fluid">
        <div v-if="outage" id="body-container" class="card card-default portal-form-background my-2 p-2">
            <div class="row">
                <div class="col text-portal-secondary-red">
                    <h5>
                        We&apos;re making some updates to our system, and your prescription information is not available at this time. We apologize for the inconvenience.
                    </h5>
                </div>
            </div>
        </div>
        <div v-if="isLoading">
            <div class="loading-div" v-if="isLoading">{{ isLoadingContent }}</div>
        </div>
        <div v-if="!(isLoading || outage)">

            <div class="row">
                <div class="col">
                    <h4 class="text-portal-soft-black pt-2">{{cmsContentBlocks['templateSelector.MainPage.Header']}}</h4>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <hr class="mt-0 mb-0 border-none taller-hr">
                </div>
            </div>

            <div class="row mt-3">
                <div class="col">
                    <h5 class="text-portal-soft-black" v-once>
                        {{cmsContentBlocks['prescriptionRefill.Header']}}
                    </h5>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <span class="text-portal-soft-red" v-once>{{cmsContentBlocks['allFieldsAreRequiredHeaderImportant']}}</span>
                    <span class="text-portal-soft-black" v-once>{{cmsContentBlocks['allFieldsAreRequiredHeader']}}</span>
                </div>
            </div>

            <div class="row d-none d-lg-block">
                <div class="col">
                    <hr>
                </div>
            </div>

            <div class="row mt-2 mt-lg-0">

                <div class="col-12 col-lg-6">

                    <div v-if="sendToThisMailbox" class="row text-portal-soft-black mb-2">
                        <div class="col" v-once>
                            To: {{sendToThisMailbox}}
                        </div>
                    </div>

                    <div v-else>
                        <div class="row text-portal-soft-black mb-2">
                            <div class="col">
                                {{cmsContentBlocks['prescriptionRefill.ToLabel']}}
                            </div>
                        </div>

                        <div class="row mb-2">
                            <div class="col">
                                <select2-component key="drDropDown" title="Send message to this person" v-error-message="{ errorModel: 'errorModel.toMailboxId' }" class="form-control" :allowclear="false" :addblankentry="false" :options="physicianDropDown" v-model="messageModel.toMailboxId" :placeholder="cmsContentBlocks['prescriptionRefill.ToDropDownPlaceHolder']">
                                </select2-component>
                                <span class="invalid-feedback is-invalid">{{ errorModel.toMailboxId | firstError }}</span>
                            </div>
                        </div>
                    </div>


                    <div v-if="showPhysicianDropDown">
                        <div class="row text-portal-soft-black mb-2">
                            <div class="col">
                                Physician
                            </div>
                        </div>

                        <div class="row mb-2">
                            <div class="col">
                                <select2-component key="physDropDown" title="Send message to this person" v-error-message="{ errorModel: 'errorModel.toPhysicianId' }" class="form-control" :allowclear="false" :addblankentry="false" :options="reassignPhysicianDropDown" v-model="messageModel.toPhysicianId" :placeholder="cmsContentBlocks['prescriptionRefill.ToDropDownPlaceHolder']">
                                </select2-component>
                            </div>
                        </div>
                    </div>

                    <div class="row text-portal-soft-black mb-2">
                        <div class="col">
                            {{cmsContentBlocks['prescriptionRefill.PharmacyLabel']}}
                        </div>
                    </div>

                    <div class="row mb-2">
                        <div class="col">
                            <select2-component :allowclear="true" title="Select a pharmacy" v-error-message="{ errorModel: 'errorModel.pharmacyId' }" url="/Patient/PreferredPharmacy/SearchPharmaciesToDropDown" :ajaxdefaultoptions="defaultPharmaciesToDisplay" v-model="messageModel.pharmacyId" :placeholder="cmsContentBlocks['prescriptionRefill.PharmacyDropDownPlaceHolder']" class="form-control"></select2-component>
                            <span class="invalid-feedback is-invalid">{{ errorModel.pharmacyId | firstError }}</span>
                        </div>
                    </div>

                    <div v-if="selectedPharmacyInformation" class="row mb-2 text-portal-soft-black">
                        <div class="col">
                            <div class="selected-pharmacy-info">

                                <div class="row">
                                    <div class="col">
                                        {{selectedPharmacyInformation.pharmacyName}} <span v-if="selectedPharmacyInformation.phoneNumber"> - {{selectedPharmacyInformation.phoneNumber | formatUsPhoneNumberWithAreaCode}} </span>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        {{selectedPharmacyInformation.address1}}
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        {{selectedPharmacyInformation.address2}}
                                    </div>
                                </div>

                                <div v-if="selectedPharmacyInformation.address3" class="row">
                                    <div class="col">
                                        {{selectedPharmacyInformation.address3}}
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        {{selectedPharmacyInformation.city}}, {{selectedPharmacyInformation.state}} {{selectedPharmacyInformation.zipCode}}
                                    </div>
                                </div>

                            </div>

                            <div v-if="!selectedPharmacyIsInYourPreferredList" class="row">
                                <div class="col">
                                    <div class="custom-control custom-checkbox mt-2">
                                        <input type="checkbox" name="AddToPreferredPharmacy" id="AddToPreferredPharmacy" v-model="messageModel.addToPreferredPharmacy" class="custom-control-input" :value="true" v-error-message="{ errorModel: 'errorModel.addToPreferredPharmacy' }">
                                        <label for="AddToPreferredPharmacy" class="custom-control-label">{{cmsContentBlocks['prescriptionRefill.AddToPrefPharmacyLabel']}}</label>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div class="row text-portal-soft-black">
                        <div class="col">
                            {{cmsContentBlocks['prescriptionRefill.SelectMedicationLabel']}}
                        </div>

                        <div class="col text-right">
                            <div v-if="messageModel.prescriptionMedicationMode == 'Prescription'">
                                <i class="fas fa-fw fa-pills mr-1"></i>
                                <a href="#" @click.prevent="messageModel.prescriptionMedicationMode = 'SearchAllDrugs'">
                                    {{cmsContentBlocks['prescriptionRefill.SearchAllDrugs']}}
                                </a>
                            </div>

                            <div v-if="messageModel.prescriptionMedicationMode == 'SearchAllDrugs'">
                                <i class="fas fa-fw fa-file-prescription"></i>
                                <a href="#" @click.prevent="messageModel.prescriptionMedicationMode = 'Prescription'">
                                    {{cmsContentBlocks['prescriptionRefill.SearchPrescription']}}
                                </a>
                            </div>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <hr class="mb-1 mt-2" />
                        </div>
                    </div>

                    <div class="row mb-2 text-portal-soft-black">
                        <div v-if="messageModel.prescriptionMedicationMode == 'Prescription'" class="col prescription-tile-container">
                            <div v-for="prescription in sortedPrescriptionList">

                                <div :id="'prescription-row-selector-' + prescription.prescriptionID" class="row align-items-center">
                                    <div class="col-auto">
                                        <div class="custom-control custom-radio mt-2">
                                            <input type="radio" v-model="messageModel.prescriptionID" name="prescriptionSelection" :id="'prescription-' + prescription.prescriptionID" class="custom-control-input" :value="prescription.prescriptionID">
                                            <label :for="'prescription-' + prescription.prescriptionID" class="custom-control-label">{{prescription.drugName}}</label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        <hr class="mt-3 mb-2" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="errorModel.prescriptionID" class="row mb-2">
                        <div class="col">
                            <span class="d-block invalid-feedback is-invalid">{{errorModel.prescriptionID | firstError}}</span>
                        </div>
                    </div>

                    <div v-if="messageModel.prescriptionMedicationMode == 'SearchAllDrugs'" class="row">
                        <div class="col">
                            <select2-component title="Medication Selection" :allowclear="true" v-error-message="{ errorModel: 'errorModel.drugId' }" url="/api/Medication/MedicationSearchDropDown" v-model="messageModel.drugId" :placeholder="cmsContentBlocks['prescriptionRefill.SelectADrugDropDownPlaceholder']" class="form-control"></select2-component>
                            <span class="invalid-feedback is-invalid">{{ errorModel.drugId | firstError }}</span>
                        </div>
                    </div>

                    <div v-if="messageModel.drugId && selectedDosageInformation" class="text-portal-soft-black mt-2">

                        <div class="row mb-2 selected-drug-info">
                            <div class="col">
                                {{cmsContentBlocks['prescriptionRefill.RouteLabel']}} {{selectedDosageInformation.selectedRoute}}
                            </div>
                        </div>

                        <div class="row mb-2 selected-drug-info">
                            <div class="col">
                                {{cmsContentBlocks['prescriptionRefill.StrengthLabel']}} {{selectedDosageInformation.selectedStrength}}
                            </div>
                        </div>

                        <div class="row mb-2 selected-drug-info">
                            <div class="col">
                                {{cmsContentBlocks['prescriptionRefill.GenericLabel']}} {{selectedDosageInformation.selectedGenericName}}
                            </div>
                        </div>

                        <div class="row mb-2">
                            <div class="col">
                                {{cmsContentBlocks['prescriptionRefill.Quantity']}}
                            </div>
                        </div>

                        <div class="row mb-2">
                            <div class="col">
                                <number-input-component mode="double" v-error-message="{ errorModel: 'errorModel.quantity' }" class="form-control" v-model="messageModel.quantity" :placeholder="cmsContentBlocks['prescriptionRefill.QuantityTextBoxPlaceholder']"></number-input-component>
                                <span class="invalid-feedback is-invalid">{{ errorModel.quantity | firstError }}</span>
                            </div>
                        </div>

                    </div>

                </div>

                <div class="col-12 col-lg-6">
                    <div class="row text-portal-soft-black mb-2">
                        <div class="col">
                            <!--<banner-component v-if="nonEnglish" :bannerText="cmsContentBlocks.messageMustBeInEnglish"></banner-component>-->
                            <message-body-component v-model="messageModel.messageBody"
                                                    :error-model="errorModel"
                                                    :cms-content-blocks="cmsContentBlocks"
                                                    :non-english="nonEnglish"></message-body-component>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<script>

    import Vue from 'vue';
    import './prescription.refill.scss';
    import formattingDirective from '@SharedVueComponents/formatting/formattingdirective';
    import errorMessageDirective from '@SharedVueComponents/Validation/ErrorMessageDirective';
    import select2Component from '@SharedVueComponents/select2/select2.vue';
    import { PharmacyHttpSvc } from '@PortalHttpServices/portal.pharmacy.httpservice';
    import { MedicationHttpSvc } from '@SharedHttpServices/medication.httpservice';
    import jlinq from '@SharedServices/linq.javascript.service.js';
    import numberInputComponent from '@SharedVueComponents/NumberInputs/NumberInput.vue';
    import composeMessageBody from '../../Common/message.body.vue';
    import mskBanner from '@PortalVueComponents/Banner/msk.banner.vue';
    import { ResolveStaticContent } from '@SharedServices/localization.service';

    export default {
        name: 'prescriptionRefill',
        props: {

            //coming from medications
            preSelectedPrescriptionId: { type: Number },
            physicianDropDown: { type: Array },
            cachedPrescriptionMedication: { type: Array },
            cachedPreferredPharmacies: { type: Array },
            cachedMskPharmacies: { type: Array },
            errorModel: { type: Object },
            cmsContentBlocks: { type: Object },
            //if set this is for ITC, DTC, etc. The "To Mailbox Id" will not be shown
            sendToThisMailbox: { type: String },
            //list of Reassign Physicians
            reassignPhysicianDropDown: { type: Array },
            //show or hide Reassign Physicians drop down
            showPhysicianDropDown: { type: Boolean },
            nonEnglish: { type: Boolean }
        },
        components: {
            'select2-component': select2Component,
            'number-input-component': numberInputComponent,
            'message-body-component': composeMessageBody,
            'banner-component': mskBanner
        },
        data: function () {
            return {
                isLoading: true,

                messageModel: {
                    toMailboxId: null, //mailbox id
                    toPhysicianId: "", //physician id
                    pharmacyId: null,
                    addToPreferredPharmacy: false, //true false
                    prescriptionMedicationMode: 'Prescription', //SearchAllDrugs
                    prescriptionID: this.preSelectedPrescriptionId,

                    drugId: null,
                    quantity: null,

                    messageBody: ''
                },

                patientsPharmacies: this.cachePreferredPharmacies,
                mskPharmacies: this.cachedMskPharmacies,
                patientPrescriptions: this.cachedPrescriptionMedication,
                selectedPharmacyInformation: null,
                selectedDosageInformation: null,
                outage: false,
            }
        },
        mounted: function () {
            this.$emit('setMessageObject', this.messageModel);

            $.when(this.getPrescriptionFromCacheOrAjax(), this.getPharmacyFromCacheOrAjax(), this.getMskPharmacyFromCacheOrAjax())
                .done((prescriptionResponse, pharmacyResponse, mskPharmacyResponse) => {
                    this.handleOutage(prescriptionResponse, pharmacyResponse, mskPharmacyResponse);
                    this.patientsPharmacies = pharmacyResponse[0];
                    this.patientPrescriptions = prescriptionResponse[0];
                    this.mskPharmacies = mskPharmacyResponse[0];

                    if (this.outage == false) {
                        this.$emit('setCachedPrescription', prescriptionResponse[0]);
                        this.$emit('setCachePreferredPharmacies', pharmacyResponse[0]);
                        this.$emit('setCacheMskPharmacies', mskPharmacyResponse[0]);
                    }


                    if (this.preSelectedPrescriptionId) {
                        Vue.nextTick(() => {
                            $('.prescription-tile-container').scrollTop($('.prescription-tile-container').scrollTop() + $('#prescription-row-selector-' + this.preSelectedPrescriptionId).position().top);
                        });
                    }

                    this.isLoading = false;
                });
        },
        computed: {

            defaultPharmaciesToDisplay: function () {

                //return a grouped select 2 data model
                return [
                    {
                        text: 'Preferred Pharmacies',
                        children: this.patientsPharmacies
                    },
                    {
                        text: 'Mskcc Pharmacies',
                        children: this.mskPharmacies
                    },

                ]
            },

            sortedPrescriptionList: function () {
                return this.patientPrescriptions.OrderBy(x => x.drugName).ToArray();
            },

            selectedPharmacyIsInYourPreferredList: function () {
                if (!this.selectedPharmacyInformation || this.patientsPharmacies.length == 0) {
                    return false;
                }

                return this.patientsPharmacies.Any(x => x.id == this.messageModel.pharmacyId);
            },

            isLoadingContent: function () {
                return ResolveStaticContent("Loading");
            }
        },
        watch: {

            selectedPharmacyIsInYourPreferredList: function (newValue, oldValue) {
                //if its in your list...reset the flag
                if (newValue) {
                    this.messageModel.addToPreferredPharmacy = false;
                }
            },

            'messageModel.pharmacyId': function (newValue, oldValue) {

                //reset the checkbox
                this.messageModel.addToPreferredPharmacy = false;

                if (!newValue) {
                    this.selectedPharmacyInformation = null;
                    return;
                }

                PharmacyHttpSvc.GetPharmacyDetail(newValue)
                    .done(response => {
                        this.selectedPharmacyInformation = response;
                    });
            },

            'messageModel.prescriptionMedicationMode': function (newValue, oldValue) {
                this.messageModel.prescriptionID = null;
                this.messageModel.drugId = null;
                this.messageModel.quantity = null;
                Vue.delete(this.errorModel, 'prescriptionID');
                Vue.delete(this.errorModel, 'drugId');
                Vue.delete(this.errorModel, 'quantity');
            },

            'messageModel.prescriptionID': function (newValue, oldValue) {
                Vue.delete(this.errorModel, 'prescriptionID');
            },

            'messageModel.drugId': function (newValue, oldValue) {
                if (newValue == null) {
                    this.selectedDosageInformation = null;
                    return;
                }

                MedicationHttpSvc.MedicationInformationSelect(newValue)
                    .done(response => {
                        this.selectedDosageInformation = response;
                    });
            },

            messageModel: {
                handler: function (newValue) {
                    this.$emit('setMessageObject', newValue);
                },
                deep: true
            },
        },
        methods: {

            getMskPharmacyFromCacheOrAjax: function () {

                if (this.cachedMskPharmacies) {
                    //in an array to match the jquery $.when
                    return $.Deferred().resolve([this.cachedMskPharmacies]);
                }

                return PharmacyHttpSvc.MskPharmaciesToDropDown();
            },

            getPharmacyFromCacheOrAjax: function () {
                if (this.cachedPreferredPharmacies) {
                    //in an array to match the jquery $.when
                    return $.Deferred().resolve([this.cachedPreferredPharmacies]);
                }

                return PharmacyHttpSvc.PatientsPreferredPharmaciesToDropDown();
            },

            getPrescriptionFromCacheOrAjax: function () {
                if (this.cachedPrescriptionMedication) {
                    //in an array to match the jquery $.when
                    return $.Deferred().resolve([this.cachedPrescriptionMedication]);
                }

                return MedicationHttpSvc.GetActiveMedications();
            },

            handleOutage: function (prescriptionResponse, pharmacyResponse, mskPharmacyResponse) {
                this.outage = false;
                if (prescriptionResponse && prescriptionResponse[0] && prescriptionResponse[0].outage === true) {
                    prescriptionResponse[0] = [];
                    this.outage = true;
                }
                if (pharmacyResponse && pharmacyResponse[0] && pharmacyResponse[0].outage === true) {
                    pharmacyResponse[0] = [];
                    this.outage = true;
                }
                if (mskPharmacyResponse && mskPharmacyResponse[0] && mskPharmacyResponse[0].outage === true) {
                    mskPharmacyResponse[0] = [];
                    this.outage = true;
                }
                if (this.outage == true) {
                    this.$emit('hideSend');
                }
            }

        }
    };
</script>

